import { HttpClientClass } from './HttpClient';

export const ApiMappings = {
  USER_ACTIONS: 'users',
  ON_YOU_API: 'onyou',
  ACCOUNT_SERVICE: 'account-service',
  TOLSTOY_API: 'tolstoy',
  STUDIO_API: 'studio',
} as const;
export type ApiMappings = (typeof ApiMappings)[keyof typeof ApiMappings];

export class ApiClient {
  private httpClient: HttpClientClass;

  constructor(apiUrl: string, private readonly servicePrefix: ApiMappings, accessToken: string = '') {
    this.httpClient = new HttpClientClass(apiUrl, accessToken);
  }

  get<T>(path: string, urlParams: Record<string, string | undefined> = {}): Promise<T> {
    return this.httpClient.get(this.getFullPath(path), urlParams);
  }

  post<T>(path: string, data: Record<string, unknown>): Promise<T> {
    return this.httpClient.post(this.getFullPath(path), data);
  }

  delete<T>(path: string, urlParams: Record<string, string> = {}): Promise<T> {
    return this.httpClient.delete(this.getFullPath(path), urlParams);
  }

  patch<T>(path: string, data: Record<string, unknown>): Promise<T> {
    return this.httpClient.patch(this.getFullPath(path), data);
  }

  private getFullPath(path: string): string {
    const pathWithPrefix = path.startsWith('/') ? path : `/${path}`;
    return `/${this.servicePrefix}${pathWithPrefix}`;
  }
}
